import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { pad } from '../../../helpers/price-helper';
import Currency from '../Currency';
const TripPrice = ({
  value,
  cents,
  converted,
  currency,
  className
}) => {
  const fractionClassName = classNames('price__fraction', {
    'price__fraction--slim': [1, 7].includes(value % 10)
  });
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: classNames('price', className)
  }, converted ? '~' : null, value, !isNil(cents) && /*#__PURE__*/React.createElement("span", {
    className: fractionClassName
  }, ",", pad(cents, 2), "\xa0")), /*#__PURE__*/React.createElement(Currency, {
    currencyCode: currency
  }));
};
TripPrice.propTypes = {
  value: PropTypes.number,
  cents: PropTypes.number,
  // eslint-disable-next-line react/boolean-prop-naming
  converted: PropTypes.bool,
  currency: PropTypes.string,
  className: PropTypes.string
};
TripPrice.defaultProps = {
  value: 0,
  cents: 0,
  converted: false,
  currency: 'RUB',
  className: ''
};
export default TripPrice;